// extracted by mini-css-extract-plugin
export default {"root":"MemoryPhotoV1_root-lnY","large":"MemoryPhotoV1_large-_Tl","small":"MemoryPhotoV1_small-vXV","none":"MemoryPhotoV1_none-tXF","image":"MemoryPhotoV1_image-IBr"};